module.exports = __webpack_public_path__ + "static/media/ic_presto.ca088268.png";